import _ from "lodash";

export const getCourseState = state => _.get(state, "courseState");
export const isCompleted = state =>
  _.get(state, "courseState.completed", false);
export const getAnswererId = state => _.get(state, "courseState.answererId");
export const getCourseId = state => _.get(state, "courseState.courseId");
